<template lang="pug">
  div(
  :class="cssClasses"
  )
    div.chart-block__head
      div.chart-block__head-title {{$translate(header)}}
      div.card-options
        div(
        @click="exportAsPng()"
        v-if="showExportBtn"
        ).btn.btn-export
        div(
        v-if="!isExpanded"
        @click="expand()"
        ).btn.btn-open
        div(
        v-if="isExpanded"
        @click="close()"
        ).btn.btn-close
    e-progress(:loading="chartLoading")
    div.chart-block__body
      div.chart-block__body-toolbar
        slot(name="chartHeader")
      div.chart-pic
        div(v-if="chartLoading === true").interest-wrapper
        div(v-if="error").interest-wrapper
          div {{error}}
        div(v-else-if="dataEmpty === true").interest-wrapper
          div {{$translate('Нет данных')}}
        div(
        :style="chartStyle"
        ref="chart"
        )
</template>

<script>
  import url from '../../utils/url.js'
  import userFriendlyEr from '../../utils/userFriendlyEr'
  import Highcharts from 'highcharts'
  import Exporting from 'highcharts/modules/exporting'
  import domtoimage from 'dom-to-image'
  import saveFile from '../../utils/saveFile'
  Exporting(Highcharts)

  export default {
    name: 'e-chart',
    props: {
      chartRedirectParams: {
        type: Object,
        default: function () {
          return null
        }
      },
      showExpandButton: {
        type: Boolean,
        default: true
      },
      auto: {
        type: Boolean,
        default: true
      },
      chartLoading: {
        type: Boolean,
        default: false
      },
      header: {
        type: String,
        default: null
      },
      options: {
        required: true,
        type: Object,
        default: function () {
          return {
            chart: { type: 'line' },
            title: '',
            xAxis: {},
            yAxis: {},
            plotOptions: {},
            credits: {}
          }
        }
      },
      series: {
        type: [Object, Array],
        default: function () {
          return []
        }
      },
      chartId: {
        required: true,
        type: String,
        default: null
      },
      defaultOptions: {
        type: Object,
        default: function () {
          return {
            chart: {
              animation: false
            },
            colors: ['#2971e4', '#85dbd9', '#5190f5', '#fbc040', '#55bad2', '#facdaa', '#8c67e3', '#f46c8b', '#fbe863', '#3b83fb'],
            exporting: {
              enabled: false
            }
          }
        }
      },
      alwaysDisableAnimation: {
        type: Boolean,
        default: false
      },
      chartError: null,
      showExportBtn: {
        type: Boolean,
        default: true
      }
    },
    mounted () {
      this.drawChart()
    },
    destroyed () {
      this.hc = null
    },
    watch: {
      'series': {
        handler: function () {
          this.updateSeries()
        },
        deep: true
      },
      'options': {
        handler: function () {
          this.updateOptions()
        },
        deep: true
      },
      '$route': function () {
        this.reflow()
      }
    },
    computed: {
      error () {
        if (this.chartError) {
          return userFriendlyEr.recognize(this.chartError)
        }
        return null
      },
      dataEmpty () {
        if (this.series && Array.isArray(this.series) && this.series[0] && this.series[0].data && this.series[0].data.length > 0) {
          return false
        }
        return true
      },
      chartStyle () {
        if (this.chartLoading === true || this.dataEmpty === true) {
          return {
            visibility: 'hidden'
          }
        }
      },
      isExpanded () {
        if (this.$route.query.expandedChart && this.chartId === this.$route.query.expandedChart) {
          return true
        } else if (this.$route.params && this.$route.params.chartId && this.$route.params.chartId === this.chartId && this.chartId) {
          return true
        }
        return false
      },
      cssClasses () {
        let tmp = ['e-chart', 'chart-block']
        if (this.chartLoading) {
          tmp.push('loading-chart')
        }
        if (this.isExpanded) {
          tmp.push('expanded-chart')
        }
        return tmp
      },
      disableAnimation () {
        if (this.alwaysDisableAnimation === true) {
          return true
        }
        if (this.$store.getters.skipAsyncData(this.$route.name)) {
          return true
        }
        return false
      }
    },
    methods: {
      exportAsPng () {
        this.$bar.start()
        domtoimage.toBlob(this.$refs.chart).then(blob => {
          let fileName = `${this.header}.png`
          saveFile({blob, fileName})
          this.$bar.finish()
        }).catch(e => {
          this.$bar.finish()
          this.chartError = e.toString()
        })
      },
      close () {
        this.$emit('close')
        if (this.auto) {
          let prevRoute = url.encode(url.getPrevRoute(this.$route))
          if (prevRoute) {
            this.redirect(prevRoute)
          } else {
            let route = url.getRoute(this.$route)
            route.query = route.query || {expandedChart: true}
            delete route.query.expandedChart
            this.redirect(route)
          }
        }
      },
      reflow () {
        this.hc.reflow()
      },
      redirect (route) {
        this.$store.commit('skipAsyncData', {name: route.name, value: true})
        this.$router.push(route, () => {
          window.scrollTo(0, 0)
          setTimeout(() => {
            this.$store.commit('skipAsyncData', {name: route.name, value: false})
          }, 50)
        })
      },
      expand () {
        this.$emit('expand')
        if (this.auto) {
          if (this.chartRedirectParams) {
            this.redirect(Object.assign(this.chartRedirectParams, {params: {chartId: this.chartId}}))
          } else {
            let route = url.getRoute(this.$route)
            if (route.query && route.query.expandedChart) {
              delete route.query.expandedChart
            } else {
              route.query.expandedChart = this.chartId
            }
            this.redirect(route)
          }
        }
      },
      getHighchart () {
        return this.hc
      },
      getOptions () {
        let options = Object.assign(this.defaultOptions, this.options, {
          series: this.series
        })
        if (this.disableAnimation) {
          options.plotOptions = options.plotOptions || {}
          options.plotOptions.series = options.plotOptions.series || {}
          options.plotOptions.series.animation = false
          options.chart = options.chart || {}
          options.chart.animation = false
        }
        return options
      },
      /*
      in computed getters for update options use:
      Object.assign({}, options, {
          chart: {
            type: chartType
          }
      })
      or call directly this.$refs.chart.updateOptions(options)
      */
      updateOptions (newOptions = null) {
        let options = Object.assign(this.getOptions(), newOptions || this.options)
        this.hc.update(options, true, true)
      },
      updateSeries () {
        let plotOptions = this.getOptions().plotOptions
        plotOptions.series = plotOptions.series || {}
        plotOptions.series.animation = this.disableAnimation
        this.hc.update({
          series: this.series,
          plotOptions
        }, true, true)
      },
      drawChart () {
        this.hc = Highcharts.chart(this.$refs.chart, this.getOptions())
      }
    }
  }
</script>
